
import { Container } from "inversify";
import { Component, Emit, Inject, Prop, Vue } from "vue-property-decorator";
import ActionButton from "../../../../common/src/components/ActionButton.vue";
import { NotificationStore } from "../../../../common/src/stores/NotificationStore";
import { SubscriptionQuoteModalStore } from "../../../../common/src/subscription-quote/SubscriptionQuoteModalStore";
import { PaymentService } from "../../../../landing/src/utility/payment/PaymentService";

@Component({
    components: { ActionButton },
})
export default class OrganizationLoadingOverlay extends Vue {
    @Inject("container") readonly container!: Container;
    readonly notificationStore: NotificationStore = this.container.get(NotificationStore);

    readonly paymentService: PaymentService = this.container.get(PaymentService);

    readonly subscriptionQuoteModalStore: SubscriptionQuoteModalStore = this.container.get(
        SubscriptionQuoteModalStore,
    );

    @Prop({ default: false }) loading!: boolean;
    @Prop({ default: false }) failed!: boolean;
    @Prop({ default: "div" }) tag!: string;

    @Emit()
    retry() {
        //
    }

    async submit() {
        this.subscriptionQuoteModalStore.open();
    }
}
